<template>
  <div class="DateDropDownSelect" :class="getStyle()">
    <div class="dis-block">
      <!-- 年选择 -->
      <el-select
        v-model="selectedYear"
        :style="{ width: yearSelectWidth + 'px' }"
        class="drop-down-select"
        placeholder="请选择年份"
        @change="handleYearChange"
      >
        <el-option
          v-for="itemc in holidayYear"
          :key="itemc.value"
          :label="itemc.label"
          :value="itemc.value"
        />
      </el-select>
      <!-- 节假日选择 -->
      <el-select
        v-if="selectedYear"
        v-model="selectedHoliday"
        :style="{ width: holidaySelectWidth + 'px' }"
        class="drop-down-select"
        placeholder="请选择节假日"
        @change="handleHolidayChange"
      >
        <el-option
          v-for="itemc in currentHolidays"
          :key="itemc.value"
          :label="itemc.label"
          :value="itemc.value"
        />
      </el-select>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
  name: 'HolidaySelection',
  props: {
    holidayData: Array,
    selectApi: String,
  },
  data() {
    return {
      selectedYear: '',
      selectedHoliday: '',
      selectWidth: 120,
      currentHolidays: [],
    };
  },
  computed: {
    ...mapState({
      componentName: state => state.ProjectInfo.CurrentScene.Charts,
    }),
    holidayYear() {
      if (!this.holidayData || this.holidayData.length === 0) {
        return [{ label: '2025年', value: '2025' }];
      }
      return this.holidayData.map(item => ({
        label: item.label,
        value: item.value,
      }));
    },
    yearSelectWidth() {
      // 年份选择框用固定宽度，显示4-5个字
      return 70;
    },
    holidaySelectWidth() {
      // 节假日选择框适配5个文字宽度
      return 5 * 14 + 20;
    },
  },
  watch: {
    holidayData: {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.initializeData();
        }
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    this.initializeData();
  },
  methods: {
    initializeData() {
      if (this.holidayData && this.holidayData.length > 0) {
        this.selectedYear = this.holidayData[0].value;
        this.updateCurrentHolidays();
      }
    },
    updateCurrentHolidays() {
      const yearItem = this.holidayData.find(item => item.value === this.selectedYear);
      if (yearItem && yearItem.children) {
        this.currentHolidays = yearItem.children;
        if (this.currentHolidays.length > 0) {
          this.selectedHoliday = this.currentHolidays[0].value;
        }
      }
    },
    handleYearChange(val) {
      this.selectedYear = val;
      this.updateCurrentHolidays();
      this.emitSelection();
    },
    handleHolidayChange(val) {
      this.selectedHoliday = val;
      this.emitSelection();
    },
    emitSelection() {
      if (this.selectedYear && this.selectedHoliday) {
        const result = ['holidays', this.selectedYear, this.selectedHoliday];
        this.$emit('holidayChange', result);
      }
    },
    getStyle() {
      let style = {};
      switch (this.componentName) {
        case 'V1Style':
          style['V1Style'] = true;
          break;
        case 'V2Style':
          style['V2Style'] = true;
          break;
        case 'V3Style':
          style['V3Style'] = true;
          break;
        case 'V4Style':
          style['V4Style'] = true;
          break;
        case 'V5Style':
          style['V5Style'] = true;
          break;
        default:
          break;
      }
      return style;
    },
  },
};
</script>

<style lang="scss" scoped>
.DateDropDownSelect {
  position: relative;
}

.drop-down-select {
  margin-left: 4px;
}

:deep().drop-down-select .el-input__inner {
  /* width: 72px; */
  height: 22px;
  line-height: 22px;
  padding-left: 4px;
  padding-right: 20px;
  background: none;
  border: 1px solid #148cdb;
  color: #03b8ca;
  font-size: 12px;
  position: relative;
}

:deep().el-input--small .el-input__icon {
  line-height: 22px;
}

:deep().el-input__suffix {
  right: 0;
  top: -8px;

  .el-input__suffix-inner {
    margin: 0;
  }
}

:deep().drop-down-select {
  &:nth-child(n + 2) {
    .el-input__inner {
      width: 100% !important;
    }
  }
}

:deep().el-select__popper.el-popper {
  background: none !important;
}

:deep().el-icon-arrow-up:before {
  color: #00f4fd;
}

.V3Style {
  :deep().drop-down-select .el-input__inner {
    width: 94px;
    height: 24px;
    line-height: 22px;
    padding-left: 10px;
    padding-right: 20px;
    background: none;
    border: 1px solid #148cdb;
    color: #03b8ca;
    font-size: 12px;
    background: linear-gradient(to top, #0c2b67, #031639, #0c2b67);
  }

  :deep().el-icon-arrow-up:before {
    color: #1597e6;
  }
}

.V4Style {
  :deep().drop-down-select .el-input__inner {
    width: 80px;
    height: 22px;
    line-height: 22px;
    padding-left: 10px;
    padding-right: 20px;
    background: none;
    border: 1px solid #8d77d8;
    color: #fff;
    font-size: 12px;
  }

  :deep().el-icon-arrow-up:before {
    color: #8d77d8;
  }
}

.V5Style {
  :deep().drop-down-select .el-input__inner {
    width: 80px;
    height: 22px;
    line-height: 22px;
    padding-left: 10px;
    padding-right: 20px;
    background: none;
    border: 1px solid #03a252;
    color: #fff;
    font-size: 12px;
  }

  :deep().el-icon-arrow-up:before {
    color: #03a252;
  }
}
@media screen and (min-width: 3300px) {
  :deep().el-input__suffix {
    top: -4px !important;
  }
  :deep().drop-down-select .el-input__inner {
    height: 33px !important;

    font-size: 18px !important;
  }
}
</style>
